/* Product enquiry context and native contact-form results. No form is submitted by this script. */
(()=>{
 const quoteKey='maxnew.quote.v1', pendingKey='maxnew.quote.pending.v1';
 function init(){
  const contact=document.getElementById('MaxnewContactForm');
  if(contact&&!contact.dataset.mxContextBound){
   contact.dataset.mxContextBound='true';
   const params=new URLSearchParams(location.search),handle=params.get('mx_product'),title=params.get('mx_title');
   const input=contact.querySelector('[data-mx-contact-product]');
   if(input&&handle&&/^[a-z0-9][a-z0-9-]{0,180}$/.test(handle)&&title&&title.length<=240){
    input.value=`${title} — /products/${handle}`;
   }
   if(input?.value)input.closest('label').hidden=false;
  }
  const quote=document.getElementById('MaxnewQuoteForm');
  if(quote&&!quote.dataset.mxReceiptBound){
   quote.dataset.mxReceiptBound='true';
   if(location.hash==='#MaxnewQuoteForm'&&quote.querySelector('[data-mx-quote-success]')){
    try{
     const pending=JSON.parse(sessionStorage.getItem(pendingKey)||'null');
     sessionStorage.removeItem(pendingKey);
     if(pending&&Date.now()-pending.at>=0&&Date.now()-pending.at<3600000&&pending.snapshot===localStorage.getItem(quoteKey)){
      localStorage.removeItem(quoteKey);
      window.dispatchEvent(new StorageEvent('storage',{key:quoteKey}));
     }
    }catch{/* A blocked browser store must never break the contact form. */}
   }
   quote.addEventListener('submit',()=>{
    try{sessionStorage.setItem(pendingKey,JSON.stringify({at:Date.now(),snapshot:localStorage.getItem(quoteKey)}))}catch{}
   });
  }
  document.querySelectorAll('#MaxnewContactForm, #MaxnewQuoteForm, #MaxnewTradeForm').forEach(form=>{
   if(form.dataset.mxFeedbackBound)return;
   form.dataset.mxFeedbackBound='true';
   const errors=form.querySelector('.errors');
   if(errors){errors.setAttribute('role','alert');errors.tabIndex=-1;if(location.hash==='#'+form.id)errors.focus()}
   const success=form.querySelector('.mx-success');
   if(success&&location.hash==='#'+form.id){success.tabIndex=-1;success.focus()}
  });
 }
 init();document.addEventListener('shopify:section:load',init);
})();
